<template>
<h3 class="kt-portlet__head-title">
    <slot></slot>
</h3>
</template>

<script>
export default {

}
</script>